// import Spline from "@splinetool/react-spline";

export default function AmbienceGreen() {
  const iconPath = process.env.PUBLIC_URL;
  return (
    // <Spline scene="https://prod.spline.design/LbxrYXYB9FGItEbY/scene.splinecode" />
    <img src={iconPath + "/ambience-green.png"} alt="" className="ambience" />
  );
}
